import styled from '@emotion/styled';
import React from 'react';

interface LayoutPresetButtonProps {
	preset: any;
	disabled: boolean;
	indexKey: number;
	handleLayoutChange: (layout: any) => void;
	t: (key: string) => string;
	small?: boolean;
	variant?: string;
}

const LayoutPresetButton: React.FC<LayoutPresetButtonProps> = (props) => {
	const { preset, disabled, indexKey, handleLayoutChange, t, small, variant } =
		props;

	const subTitle = preset.layout.tags$General.find((e: string) =>
		e.includes('Medium:'),
	);

	const subTitleString = subTitle?.substr(subTitle.lastIndexOf(':') + 1) ?? '';

	const subTitleText =
		subTitleString && subTitleString === 'Print'
			? `${subTitleString} Product`
			: subTitleString;

	const StyledButton = styled.div<{ isSmall?: boolean }>`
		display: flex;
		align-items: center;
		width: 100%;
		border-radius: var(--bs-border-radius-sm);
		border: 1px solid var(--bs-gray-200);
		cursor: pointer;

		margin-bottom: ${(props) => (props.isSmall ? ' 1rem;' : '')};

		&.disabled {
			opacity: 0.5;
			pointer-events: none;
		}

		&:hover,
		&:focus {
			border-color: ${(props) =>
				props.isSmall ? 'var(--bs-25);' : 'var(--bs-blue-500);'};
		}
	`;

	const classNameArray = [
		'layout-preset-button',
		'py-2',
		'px-3',
		disabled ? 'disabled' : '',
	];

	if (small) {
		classNameArray.push(small ? 'py-1 my-2' : '');
	}

	if (variant) {
		classNameArray.push(`border-${variant} text-${variant}`);
	}

	return (
		<StyledButton
			key={indexKey}
			className={classNameArray.join(' ')}
			isSmall={small}
			role="button"
			onClick={() => handleLayoutChange(preset.layout)}
		>
			{preset.icon && (
				<span
					className={`${small ? '' : 'bg-primary-subtle text-primary'}`}
					style={{ padding: '0.85rem', borderRadius: 6 }}
				>
					{preset.icon}
				</span>
			)}
			<div>
				<p className="text-left justify-content-start mb-0">
					<span className="ps-3 fw-bold">{t(preset.label)}</span>
				</p>
				<p className="text-left justify-content-start my-1">
					<span className="ps-3 mt-2 text-400 text-capitalize">
						{t(subTitleText)}
					</span>
				</p>
			</div>
		</StyledButton>
	);
};

export default LayoutPresetButton;
